import { SblContainer, SBLProps } from './SBLContainer';

export default function SBL(props: SBLProps) {
  return <SblContainer {...props} />;
}
